import { useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';
import { IFitoListItem } from '.';
import { RearrangeStatus } from './models/RearrangeStatus.enum';

interface IFitoListProps {
  onTabbedFilterChange?: (index: number) => void;
  items: IFitoListItem[];
  setIsBeingRearranged?: (isBeingRearranged: boolean) => void;
  onRearrange?: (newList: IFitoListItem[]) => void;
  onSelect?: (id: string | string[], checked?: boolean) => void;
}

export const useFitoList = ({
  onTabbedFilterChange,
  items,
  setIsBeingRearranged,
  onRearrange,
  onSelect,
}: IFitoListProps) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  const [rearrangedList, setRearrangedList] = useState<IFitoListItem[]>(items);
  const [value, setValue] = useState(0);

  const handleChange = useCallback(
    (event: React.ChangeEvent<{}>, newValue: number) => {
      setValue(newValue);
      onTabbedFilterChange?.(newValue);
    },
    [setValue, onTabbedFilterChange],
  );

  const onRearrangeAction = (status: RearrangeStatus) => {
    switch (status) {
      case RearrangeStatus.STARTED:
        setIsBeingRearranged?.(true);
        break;
      case RearrangeStatus.DONE:
        setIsBeingRearranged?.(false);
        onRearrange?.(rearrangedList);
        break;
      case RearrangeStatus.CANCELED:
      default:
        setRearrangedList(items);
        setIsBeingRearranged?.(false);
    }
  };

  const options = {
    enableMouseEvents: !mobile,
  };

  const onSelectAll =
    onSelect &&
    (() => {
      const isAllSelected =
        rearrangedList.length === rearrangedList.filter((item) => item.checked).length;
      onSelect(
        rearrangedList.map((item) => item.id),
        !isAllSelected,
      );
    });

  useEffect(() => {
    setRearrangedList(items);
  }, [items]);

  return {
    onRearrangeAction,
    onItemRearranged: setRearrangedList,
    options,
    handleChange,
    value,
    rearrangedList,
    onSelectAll,
  };
};
